import { formatEther } from "viem";
import { AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { fmtNum } from "../lib/format";
import { addrUrl } from "../lib/chains";

const R = ({ k, v }) => <div className="flex justify-between py-1.5 text-xs border-b border-white/5"><span className="text-slate-500">{k}</span><span className="font-mono text-slate-200 text-right">{v}</span></div>;

const BLOCK_IMPACT = 15;

export const SwapReview = ({ open, onOpenChange, onConfirm, tokenIn, tokenOut, amount, outFmt, minOut, quote, slippage, router, route }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[#12161F] border-lime/20 max-w-md text-slate-100" data-testid="swap-review-dialog">
      <DialogHeader><DialogTitle className="font-display tracking-wide">Review swap</DialogTitle></DialogHeader>
      <div className="rounded-lg bg-black/40 p-4 space-y-1">
        <p className="text-xs text-slate-500">You pay</p>
        <p className="text-2xl font-mono font-bold">{fmtNum(amount, 8)} {tokenIn.symbol}</p>
        <p className="text-xs text-slate-500 pt-2">You receive (estimated)</p>
        <p className="text-2xl font-mono font-bold text-lime">{fmtNum(outFmt, 8)} {tokenOut.symbol}</p>
      </div>
      <div>
        <R k="Minimum received" v={`${fmtNum(minOut, 8)} ${tokenOut.symbol}`} />
        <R k="Slippage tolerance" v={`${slippage}%`} />
        {quote.fees?.length > 0 && <R k="HIVEVORA swap fee" v={quote.fees.map((f) => `${f.bips / 100}% to ${f.roles.join(" + ")} ${f.recipient.slice(0, 6)}…${f.recipient.slice(-4)}`).join(" · ")} />}
        <R k="Price impact" v={`${quote.priceImpact.toFixed(3)}%`} />
        <R k="Route" v={route} />
        <R k="Pool fees (paid to LPs)" v={quote.poolFees?.length ? quote.poolFees.map((f) => `${f / 10000}%`).join(" + ") : "included in quote"} />
        <R k="Est. network gas" v={`${fmtNum(formatEther(quote.gasWei), 8)} ETH`} />
        <R k="HIVEVORA platform fee" v="None" />
        <R k="Network" v="Robinhood Chain (4663)" />
        <R k="Contract" v={quote.source === "api" ? "Uniswap Universal Router (from Trading API)" : <a href={addrUrl(router)} target="_blank" rel="noreferrer" className="text-lime hover:underline">Uniswap SwapRouter02</a>} />
        {quote.source === "api" && <R k="Steps" v={tokenIn.address === "native" ? "Swap" : "Approve Permit2 (once) → sign permit → swap"} />}
        <R k="Deadline" v="20 minutes" />
      </div>
      {quote.priceImpact > 5 && <p className="flex gap-2 text-xs text-danger"><AlertTriangle className="h-4 w-4 shrink-0" /> Very high price impact — you may lose a large share of value.</p>}
      {[tokenIn, tokenOut].some((t) => t.kind === "robinhood_stock_token") && (
        <p data-testid="swap-stock-token-notice" className="text-[11px] text-warning/90">Stock Tokens are issued by Robinhood and track an underlying equity (see multiplier). Eligibility and transfer restrictions may apply in your jurisdiction — a restricted transfer will revert on-chain.</p>
      )}
      <p className="text-[11px] text-slate-500">Your wallet will ask you to sign. HIVEVORA only reports success after the transaction is confirmed on-chain.</p>
      <button data-testid="swap-confirm-button" disabled={quote.priceImpact > BLOCK_IMPACT} onClick={onConfirm} className="btn-lime w-full py-3 text-sm disabled:opacity-40 disabled:cursor-not-allowed">
        {quote.priceImpact > BLOCK_IMPACT ? `Blocked: price impact above ${BLOCK_IMPACT}%` : "Confirm swap in wallet"}
      </button>
    </DialogContent>
  </Dialog>
);
